import React from 'react';
import { TooltipPositionToArrowOffsetMap, TooltipPositionToTippyOffsetMap, TooltipPositionToTippyPlacementMap } from './tooltip.maps';
import { TooltipBox } from './tooltip.styles';
export function Tooltip(props) {
  const {
    position = 'top-start',
    arrowOffset = TooltipPositionToArrowOffsetMap[position],
    offset = TooltipPositionToTippyOffsetMap[position],
    maxWidth = 240,
    zIndex = 999999,
    isDisabled,
    isVisible,
    ...rest
  } = props;
  return React.createElement(TooltipBox, {
    animation: false,
    delay: 0,
    duration: 0,
    disabled: isDisabled,
    maxWidth: maxWidth,
    zIndex: zIndex,
    placement: TooltipPositionToTippyPlacementMap[position],
    visible: isVisible,
    "$position": position,
    "$arrowOffset": arrowOffset,
    popperOptions: {
      strategy: 'fixed',
      modifiers: [{
        name: 'offset',
        options: {
          offset
        }
      }, {
        name: 'flip',
        options: {
          fallbackPlacements: []
        }
      }, {
        name: 'preventOverflow',
        options: {
          mainAxis: false
        }
      }]
    },
    ...rest
  });
}